/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartMakeOfferButton_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemCTA_user$ref: FragmentReference;
export type CartItemCTA_user = {|
  +serviceId: ?string,
  +$fragmentRefs: CartMakeOfferButton_user$ref,
  +$refType: CartItemCTA_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemCTA_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartMakeOfferButton_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1fecb4bc4a71a3ea3b971ea45c773c47';
module.exports = node;
